import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Content } from '../components/Content';

class AccountAlreadExist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            errors: [],
            loading: false,
            account: '',
            fullName: '',
            fromRedirect: false
        };
    };

    componentDidMount() {

        let { uid, fullName, account } = this.props.location.state;
        //const fromRedirect = this.props.history.action !== 'POP';

        // if (!fromRedirect) {
        //     return this.props.history.push({
        //         pathname: '/'                
        //     })
        // }

        this.setState(
            {
                uid: uid,
                fullName: fullName,
                account: account,
                fromRedirect: this.props.history.action === 'PUSH'
            }
        );
    };

    renderSuccessMessage(fullName, account) {
        return (
            <Content stepName="Conta institucional existente">
                <div className="jumbotron jumbotron-fluid bg-info text-light text-center">
                    <div className="container">
                        <h2 className="text">Olá, </h2>
                        <h3>{fullName}</h3>
                        <p className="lead">Você já possui uma conta institucional para utilizar os sistemas da UFVJM e ela é: <span className="text display-4">{account}</span></p>
                    </div>
                </div>
                <Link to={`${process.env.PUBLIC_URL}/`}>Cancelar</Link>
            </Content>                          
        );
    }

    render() {
        const { fullName, account } = this.state;
        return (
            this.renderSuccessMessage(fullName, account)
        )
    }
}

export default AccountAlreadExist;